export default __webpack_public_path__ + "static/media/mike.0b29fb34.jpg";